import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check session storage to see if the button was dismissed in this session
    const isDismissed = sessionStorage.getItem('whatsapp_button_dismissed');
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(false);
    sessionStorage.setItem('whatsapp_button_dismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center justify-center group">
      <div className="relative flex items-center">
        <span className="pointer-events-none absolute right-16 hidden whitespace-nowrap rounded-full bg-white/90 px-4 py-2 text-sm font-semibold text-dark-700 shadow-lg backdrop-blur sm:block">Need help? Chat with us live.</span>
        <a
          href="https://wa.me/16478726713"
          target="_blank"
          rel="noopener noreferrer"
          className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-full bg-[#25D366] shadow-lg ring-4 ring-white transition-transform duration-300 hover:scale-105"
          aria-label="Chat with us on WhatsApp"
        >
          <img src={`${process.env.PUBLIC_URL || ''}/images/whatsapp.webp`} alt="WhatsApp" className="h-full w-full object-cover" />
        </a>
        <button
          onClick={handleClose}
          className="absolute -top-1 -right-1 bg-white text-gray-500 rounded-full shadow-md hover:bg-gray-100 hover:text-gray-800 transition-colors duration-200 z-10 border border-gray-200 flex items-center justify-center w-5 h-5"
          aria-label="Close WhatsApp button"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default WhatsAppButton;
